import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { CohortAddUserComponent } from "./component";
import { useNavigate, useParams } from "react-router-dom";
import {  toast } from "react-toastify"
const CohortAddUserContainer = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [seedData, setSeedData] = useState({ users: [] });
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [cohortDetailsData, setCohortDetailsData] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    handleGetSeedData();
    LoadCohortViewDetails();
  }, []);

  
  const handleGetSeedData = () => {
    const url = `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/seed`;

    props.getDataFromAPI(
      url,
      "GET",
      undefined,
      (response) => {
        setSeedData(response);
        setLoading(false);
      },
      (err) => {
        toastr.error("Failed", "Unable to fetch seed data");
        setLoading(false);
      }
    );
  };

 
  const LoadCohortViewDetails = () => {
    props.getDataFromAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${id}`,
      "GET",
      undefined,
      (response) => {
        setCohortDetailsData(response);
        setLoading(false);

        if (response?.users) {
          const selectedUserIds = response.users.map((user) => user.id);
          setSelectedUsers(response.users); 
        }
      },
      (err) => {},
      true
    );
  };

  const handleUserSelection = (user, isSelected) => {
    setSelectedUsers(isSelected
      ? [...selectedUsers, user]
      : selectedUsers.filter((u) => u.id !== user.id)
    );
  };

  const handleUpdateUser = async () => {
    if (!selectedUsers.length) { 
      setErrors((prevErrors) => ({
        ...prevErrors,
        selectedUsers: "At least one user must be selected", 
      }));
      return;  
    }
  
    try {
      const url = `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${id}/users`
      const requestBody = selectedUsers.map((user) => user.id);
  
      props.getDataFromAPI(url, "POST", requestBody, (response) => {
        setSelectedUsers([]); 
        setErrors({}); 
        navigate(-1);
      });
    } catch (err) {
      console.log("err cohort create api ", err.message);
      toastr.error(`${err.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    }
  };

  return (
    <CohortAddUserComponent
      loading={loading}
      errors={errors}
      seedData={seedData}
      selectedUsers={selectedUsers}
      onUserSelect={handleUserSelection}
      handleUpdateUser={handleUpdateUser}
      cohortDetailsData={cohortDetailsData}
      
    />
  );
};

export default connect(null, { getDataFromAPI })(CohortAddUserContainer);
